import { motion, useReducedMotion } from "framer-motion";
import { ReactNode } from "react";

interface PageTransitionProps {
  children: ReactNode;
}

/** Fade pages without retaining a filtered compositor layer over the entire document. */
const PageTransition = ({ children }: PageTransitionProps) => {
  const reducedMotion = useReducedMotion();
  return (
    <>
      {/* Light sweep across the top while pages swap */}
      <motion.div
        className="fixed top-0 left-0 right-0 h-[3px] z-[100] pointer-events-none origin-left"
        style={{
          background:
            "linear-gradient(90deg, transparent, hsl(var(--primary) / 0.9), hsl(var(--accent, var(--primary)) / 0.9), transparent)",
        }}
        initial={{ scaleX: 0, opacity: 0 }}
        animate={{ scaleX: 1, opacity: [0, 1, 1, 0] }}
        exit={{ scaleX: 0, opacity: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      />
      <motion.div
        className="smooth-page"
        initial={{ opacity: reducedMotion ? 1 : 0 }}
        animate={{ opacity: 1 }}
        exit={{
          opacity: 0,
          transition: { duration: reducedMotion ? 0 : 0.12 },
        }}
        transition={{ duration: reducedMotion ? 0 : 0.3, ease: "easeOut" }}
      >
        {children}
      </motion.div>
    </>
  );
};

export default PageTransition;
